import React, { useState } from "react";

const ProductDescriptionTabs = ({
  description,
  otherDescription,
  additionalInformation,
}) => {
  const [activeTab, setActiveTab] = useState("description"); // default tab

  console.log("otherDescription", otherDescription);

  const tabClass = (tabName) =>
    `relative px-4 py-3 text-sm sm:text-base font-semibold transition-all duration-300 whitespace-nowrap ${
      activeTab === tabName
        ? "text-[#1e242a]"
        : "text-[#5f6870] hover:text-[#1e242a]"
    }`;

  return (
    <div className="mx-auto mt-10 max-w-6xl px-4 sm:px-6 lg:px-8">
      <div className="overflow-hidden rounded-[28px] border border-[#1e242a]/10 bg-white shadow-[0_20px_55px_rgba(30,36,42,0.10)]">
        {/* Tabs */}
        <div className="border-b border-[#1e242a]/10 bg-[#f5f6f5]">
          <div className="flex overflow-x-auto px-3 sm:px-5">
            <button
              className={tabClass("description")}
              onClick={() => setActiveTab("description")}
            >
              Description
              {activeTab === "description" && (
                <span className="absolute bottom-0 left-4 right-4 h-[3px] rounded-full bg-[#1e242a]" />
              )}
            </button>

            <button
              className={tabClass("otherDescription")}
              onClick={() => setActiveTab("otherDescription")}
            >
              Other Description
              {activeTab === "otherDescription" && (
                <span className="absolute bottom-0 left-4 right-4 h-[3px] rounded-full bg-[#1e242a]" />
              )}
            </button>

            <button
              className={tabClass("shipping")}
              onClick={() => setActiveTab("shipping")}
            >
              Shipping & Return
              {activeTab === "shipping" && (
                <span className="absolute bottom-0 left-4 right-4 h-[3px] rounded-full bg-[#1e242a]" />
              )}
            </button>
          </div>
        </div>

        {/* Tab Panels */}
        <div className="min-h-[150px] bg-white p-5 sm:p-6 md:p-8">
          {activeTab === "description" && (
            <div
              className="prose max-w-none prose-headings:text-[#1e242a] prose-p:text-[#5f6870] prose-li:text-[#5f6870] prose-strong:text-[#1e242a]"
              dangerouslySetInnerHTML={{ __html: otherDescription }}
            />
          )}

          {activeTab === "otherDescription" && (
            <div
              className="prose max-w-none prose-headings:text-[#1e242a] prose-p:text-[#5f6870] prose-li:text-[#5f6870] prose-strong:text-[#1e242a]"
              dangerouslySetInnerHTML={{ __html: additionalInformation }}
            />
          )}

          {activeTab === "shipping" && (
            <div className="space-y-8 text-[#5f6870]">
              {/* Shipping Policy */}
              <div className="rounded-2xl border border-[#1e242a]/10 bg-[#f5f6f5] p-6 shadow-sm">
                <h3 className="mb-4 flex items-center gap-2 text-xl font-semibold text-[#1e242a]">
                  🚚 Shipping Policy
                </h3>

                <ul className="list-inside list-disc space-y-2">
                  <li>Order processing time is 2–4 business days after design approval.</li>
                  <li>Standard shipping takes 5–7 business days.</li>
                  <li>Rush shipping options are available at checkout.</li>
                  <li>Tracking details will be shared via email once shipped.</li>
                </ul>
              </div>

              {/* Returns & Refunds */}
              <div className="rounded-2xl border border-[#1e242a]/10 bg-[#f5f6f5] p-6 shadow-sm">
                <h3 className="mb-4 flex items-center gap-2 text-xl font-semibold text-[#1e242a]">
                  🔄 Returns & Refunds
                </h3>

                <ul className="list-inside list-disc space-y-2">
                  <li>All products are custom-made; returns are not accepted.</li>
                  <li>Refunds or replacements are only offered for damaged or incorrect items.</li>
                  <li>Issues must be reported within 48 hours of delivery.</li>
                  <li>Orders cannot be canceled once production has started.</li>
                </ul>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductDescriptionTabs;